import { LevelType } from '@/components/common/k-score/get-level'
import { I18nId } from '@/i18n/config'

const getKScoreLevelI18nId = (score: LevelType): I18nId => {
  switch (score) {
    case LevelType.Excellent:
      return 'kol:score_excellent_text'
    case LevelType.Good:
      return 'kol:score_good_text'
    case LevelType.Normal:
      return 'kol:score_normal_text'
    case LevelType.Bad:
      return 'kol:score_bad_text'
  }
}

export default getKScoreLevelI18nId
